import { Component, OnInit, Optional, Inject } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { OrderStatusEventEmitterService } from '../../services/orderStatusEventEmitterService.component';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { NxiContextUtils } from '@pershing/nxi-common';
import { Subscription } from 'rxjs';
import { OSFService } from '../../services/OSFService.component';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
    selector: 'new-order-status-filter',
    templateUrl: './NewOrderStatusFilter.component.html',
    styleUrls: ['./NewOrderStatusFilter.component.css']
  })
  export class NewOrderStatusFilterComponent implements OnInit {
    data: any;
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    tradeStatusOptions: string[] = ['ALL', 'OPEN', 'PENDING', 'EXECUTED', 'CANCELED', 'REJECTED', 'AWAITING_SALE'];
    tradeStatus: string = 'ALL';
    symbolValue: string = '';
    serviceUrl: any;
    down: any;
    ismobile: boolean = false;
    isAdaTheme: boolean = false;
    filterVisible: boolean = false;
    ifSymbol: boolean = false;
    error: any;
    constructor(private  osfservice: OSFService,
                private contextService: IContextService,
                private ee: OrderStatusEventEmitterService, private nxiRestService: NxiRestService,
                private translationService: PershingTranslationService, @Optional() @Inject('AppSettings') appSettings: any) {
                this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
                if (appSettings.deviceType === 'mobile') {
                  this.ismobile = true;
                }
                if (appSettings.themeType && appSettings.themeType === 'ada') {
                  this.isAdaTheme = true;
                }
         }
    ngOnInit() {
      this.serviceUrl = this.nxiRestService.serviceUrl ;
      this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
        let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
       // this.inputValue = contextValue.inputValue;
        this.acctRef = contextValue.hashValue;
        this.download();
        this.onSubmit();
    });
    }
    onSubmit() {
    this.download();
    let params = new HttpParams();
    if (this.symbolValue) {
              this.ifSymbol = true;
              params = params.append('symbol', this.symbolValue);
    }
    params = params.append('orderStatusCode', this.tradeStatus);
    this.osfservice.orderStatusFilter(this.acctRef, params, this.serviceUrl).subscribe(
      data => {
        if (data['length'] !== 0) {
        this.data = data;
        this.ee.emitda(this.data);
        } else {
          this.data = null;
          this.ee.emitda(this.data);
        }
      },
      err => {
        console.error(err);
        this.error = err;
       },
        () => console.log('data recieved')
    );
    }
    download() {
      this.down = (this.serviceUrl + '/trading/' +  this.acctRef + '/orders?isDownload=true&orderStatusCode=' + this.tradeStatus + '&symbol=' + this.symbolValue);
    }
    showFilter() {
      this.filterVisible = !this.filterVisible;
      console.log('filterVisible', this.filterVisible);
    }
}
